import { Button, Classes } from '@blueprintjs/core'
import moment from 'moment-timezone'
import React from 'react'
import InfiniteScroll from 'react-infinite-scroller'
import { CLIENTS, LEVELS, STATES, SPECIALITIES, ERROR_TOAST_ICON,FROM_TO_DATE_TIME } from '../../../utils/Constants'
import LoadingSpinner from '../../loadingSpinner'
import { getTrip, getTrips } from '../../services/tripApiService'
import {
  backToTopButton, flexCenter, justifyCenter,
  footerButtonsContainer, openTripsHeaderContainer, openTripsHeaderSubcontainer,
  popoverContainerDiv, refreshButtonContainer, tripsSpan, lateTripsContainer
} from '../../styles'
import { AppToaster } from "../../toastComponent"
import FilterModal, { getFilters, getSpecialtyFilter,getDateTimeFilter } from '../modalComponents/filterModal'
import TripsDetailsComponent from '../tripDetails/tripsDetailsComponent'
import LateTripsTable from './lateTripsTable'

const localserviceArea = JSON.parse(localStorage.getItem('serviceAreaCheckboxs'));
const localclientOptions = JSON.parse(localStorage.getItem('clientOptionsCheckboxs'));
const locallevelOptions = JSON.parse(localStorage.getItem('levelOptionsCheckboxs'));
const localspecialtyOptions = JSON.parse(localStorage.getItem('specialtyOptionsCheckboxs'));
const localFromToDateTime = JSON.parse(localStorage.getItem('fromToDateTimeValues'));

export default class LateTripsContainer extends React.Component {

  state = {
    offsetCount: 0,
    tripsTop: 100,
    isLoadMoreVisible: false,
    isLoadMoreDisabled: true,
    trips: [],
    selectedTrip: null,
    selectedRow: null,
    isLoading: true,
    isOpenFilter:null,
    serviceAreaCheckboxs: localserviceArea ? localserviceArea : STATES,
    clientOptionsCheckboxs: localclientOptions ? localclientOptions : CLIENTS,
    levelOptionsCheckboxs: locallevelOptions ? locallevelOptions : LEVELS,
    specialtyOptionsCheckboxs: localspecialtyOptions ? localspecialtyOptions : SPECIALITIES,
    fromToDateTimeValues : localFromToDateTime ? localFromToDateTime : FROM_TO_DATE_TIME,
    sortBy: 'DueTime',
    sortOrder: 'ASC',
    dueDate: new Date(),
    tableRef: React.createRef(),
    isLoadingKeyEvents: false,
    isLoadingDetails: false,
  }

  handleBackToTopClick = () => {
    this.state.tableRef.current.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
    });
  }

  handleScroll = (event) => {
    this.setState({
      isLoadMoreVisible: event.target.scrollTop > 0 ? true : false,
    })
  }

  handleLoadMore = async () => {
    if (this.state.trips.length === 0) {
      return;
    }

    var offsetCount = this.state.offsetCount + 1;

    await this.setState({
      isLoadMoreDisabled: true,
      isLoading: true,
    });
    await this.getTrips(offsetCount);
  }

  getTrips = async (offsetCount) => {
    
    if(this.state.fromToDateTimeValues.some((dateTime) => !dateTime.date || !dateTime.time )){
			AppToaster.show({ message: "From/To Date and Time are required", intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });
			this.setState({
				isLoading: false,
        isOpenFilter: true
			});
      
      this.setState({isOpenFilter: null});
			return;
		}

    try {
      const offset = this.state.tripsTop * offsetCount;
      const stateFilter = getFilters(this.state.serviceAreaCheckboxs);
      const clientFilter = getFilters(this.state.clientOptionsCheckboxs);
      const levelFilter = getFilters(this.state.levelOptionsCheckboxs);
      var isVip = getSpecialtyFilter(this.state.specialtyOptionsCheckboxs, "isVip");
      var isOversizeWC = getSpecialtyFilter(this.state.specialtyOptionsCheckboxs, "isOversizeWC");
      var isDialysis = getSpecialtyFilter(this.state.specialtyOptionsCheckboxs, "isDialysis");
      var fromDateTime = getDateTimeFilter(this.state.fromToDateTimeValues, "fromDateTime");
      var toDateTime = getDateTimeFilter(this.state.fromToDateTimeValues, "toDateTime");

      let trips = this.state.trips;
      let newTrips = [];

      const params = {
        status: 'Accepted,Confirmed,Offered', top: this.state.tripsTop, offset: offset, state: stateFilter,
        sortBy: this.state.sortBy, sortOrder: this.state.sortOrder, client: clientFilter, serviceLevel: levelFilter,
        dueTimeBeforeTripLocalTime: toDateTime, dueTimeAfterTripLocalTime: fromDateTime,
        serviceMethod: 'Bolt,MDD,RideShare', isVip: isVip, WheelchairType: isOversizeWC, dialysis: isDialysis
      }

      Object.keys(params).forEach((key) => (params[key] == null || params[key] === '') && delete params[key]);

      newTrips = await getTrips(params);

      newTrips = this.getFilteredLateTrips(newTrips);

      if (newTrips.length === 0) {
        AppToaster.show({ message: 'No trips found.', intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });

        return;
      }

      trips = trips.concat(newTrips);

      this.setState({
        offsetCount: offsetCount,
        trips: trips,
        isLoadMoreDisabled: newTrips.length < this.state.tripsTop ? true : false,
      })
    }
    catch (error) {
      console.log(error);
    }
    finally {
      this.setState({
        isLoading: false,
      })
    }
  }

  getFilteredLateTrips = (trips) => {

    const filteredLateTrips = [];

    trips.forEach(trip => {
      const now = moment.tz(trip.pickupTimeZone);
      const dueDateTime = moment.tz(trip.dueDateTime, trip.pickupTimeZone);
      const diff = dueDateTime.diff(now);

      if (diff <= 0) {
        filteredLateTrips.push(trip);
      }
    });

    return filteredLateTrips;
  }

  setSelectedTrip = async (e) => {
    try {
      if (e.currentTarget !== this.state.selectedRow) {
        const tripNumber = e.currentTarget.getAttribute('id');
        if (this.state.selectedRow != null) {
          const selectedRow = this.state.selectedRow;
          selectedRow.bgColor = '';

          this.setState({
            selectedRow: selectedRow,
          })
        }

        var currentTarget = e.currentTarget;
        currentTarget.bgColor = this.props.themeName === Classes.DARK ? '#00000020' : '#cccccc';

        await this.setState({
          selectedRow: currentTarget,
          isLoadingDetails: true,
          isLoadingSpinner: true,
          isLoadingKeyEvents: true,
        })
        const trip = await getTrip(tripNumber);

        this.setState({
          selectedTrip: trip,
          isLoadingDetails: false
        });
      }
    }
    catch (error) {
      console.log(error);
      let message = 'Unexpected error';

      if (error.response?.status === 404) {
        message = 'No trip found.';
      }
      AppToaster.show({ message: message, intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });
    }
  }

  refreshTrips = async (sortBy, sortOrder) => {
    await this.setState({
      isLoadMoreVisible: false,
      isLoadMoreDisabled: true,
      offsetCount: 0,
      trips: [],
      selectedTrip: null,
      isLoading: true,
      sortBy: sortBy,
      sortOrder: sortOrder
    });

    this.getTrips(this.state.offsetCount);
  }

  handleFilter = async () => {
    this.refreshTrips(this.state.sortBy, this.state.sortOrder);
  }

  componentDidMount() {
    this.getTrips(this.state.offsetCount);

    this.props.handleHeaderPathChange('Late Trips');
  }

  handleKeySpinner() {
    this.setState({ isLoadingKeyEvents: false });
  }

  handleDateChange = (date) => {
    this.setState({
      dueDate: date,
    });

  }

  hadleDatePickerClose = () => {
    this.refreshTrips(this.state.sortBy, this.state.sortOrder);
  }


  render() {
    var tripsCount = this.state.trips.length;

    return (
      <div style={lateTripsContainer}>
        {this.state.isLoading ? <LoadingSpinner /> : <></>}
        <div style={openTripsHeaderContainer}>
          <div style={openTripsHeaderSubcontainer (this.props.themeName === Classes.DARK)}>
            <div style={flexCenter}>
              <span style={tripsSpan}>Trips: {tripsCount}</span>
              <div style={popoverContainerDiv}>
                <FilterModal fatherComponent={this} />
              </div>
            </div>
            <div style={refreshButtonContainer}>
              <Button icon="refresh" text="Refresh" onClick={() => this.refreshTrips(this.state.sortBy, this.state.sortOrder)} />
            </div>
          </div>

          <div className="container" onScroll={this.handleScroll}>
            <InfiniteScroll
              loadMore={this.handleLoadMore}
              hasMore={!this.state.isLoadMoreDisabled}
              threshold={100}
              useWindow={true}
              getScrollParent={() => this.scrollParentRef}
            >
              <div className="mt-5 mx-auto" ref={this.state.tableRef}>
                <LateTripsTable
                  trips={this.state.trips}
                  themeName={this.props.themeName}
                  setSelectedTrip={this.setSelectedTrip}
                  selectedTrip={this.state.selectedTrip}
                  refreshTrips={this.refreshTrips}
                  customFields={this.state.trips?.customFields}
                />
              </div>
            </InfiniteScroll>
          </div>
          {this.state.isLoadMoreVisible ?
            <footer style={footerButtonsContainer}>
              <div style={justifyCenter}>
                <Button style={backToTopButton} icon="arrow-up" type="button" onClick={this.handleBackToTopClick} text="Back to top" intent={'primary'} />
              </div>
            </footer> : null
          }
        </div>
        {
          <TripsDetailsComponent
            selectedTrip={this.state.selectedTrip}
            handleKeySpinner={this.handleKeySpinner.bind(this)}
            isLoadingKeyEvents={this.state.isLoadingKeyEvents}
            isLoadingDetails={this.state.isLoadingDetails}
          />
        }
      </div >
    )
  }
}
